import React, {useEffect, useState} from "react";
import {useForm} from 'react-hook-form';

const Test =()=>{
    const deptos = [{codigo:-1, nombre:"-1"},{codigo:1, nombre:"1"}];
    const muns = [{codigo:-1, nombre:"-1"},{codigo:1, nombre:"1"}];

    const [idDepto2, setIdDepto2] = useState(-1);    
    const [idMun, setIdMun] = useState(-1);

    const {register, handleSubmit, watch, formState: { errors }, setValue} = useForm();

    const esMayorOIgualACero = (valor) => {  
        console.log("validando mayor o igual a cero " + valor)
        return parseInt(valor) >= 0;
    };

    const handleChangeDepto2 = (e) => {
        console.log("cambiando depto")
        setIdDepto2(e.target.value);
    };

    const handleChangeMun2 = (e) => {    
        console.log("cambiando mun")
        setIdMun(e.target.value);        
    };

    useEffect( ()=>{ 
        setIdMun(idDepto2);
        setValue("selMun", idDepto2)
    }, [idDepto2] );

    const regDepto2 = register("selDepto", { required: true, validate: esMayorOIgualACero });
    const regMun2 = register("selMun", { required: false, validate: esMayorOIgualACero });
    const onSubmit = (data)=>{        
        console.log("onsubmit invocado data de la pagina")
        console.log(data)        
    }

    const onError = (errors, e) => {
        console.log("forma no pudo hacer submit")
        console.log(errors, e);
    }

    return (        
        <form onSubmit={handleSubmit(onSubmit, onError)}>
            <SelectWithReactHookForm reg={regDepto2} handleChange={handleChangeDepto2} opciones={deptos} valor={idDepto2}/>
            <SelectWithReactHookForm reg={regMun2} handleChange={handleChangeMun2} opciones={muns} valor={idMun}/>   
            <input type="submit"></input>
        </form>
    )
}

const SelectWithReactHookForm = ({reg, handleChange, opciones, valor})=> {
    const hc = handleChange? handleChange: (e)=>{}
    console.log("srhf2 "+reg.name+ " valor" + valor)
    console.log(reg.ref)
    return (
        <select  {...reg} 
        onChange={(e) => {
            console.log("onchange de srhf2 " + reg.name)
            console.log(e)
            reg.onChange(e);
            hc(e);
        }}
        defaultValue={valor}
        value={valor}
        >{
        opciones.map((o, index) => {
            let key = o.codigo
        
            return (
              <option value={o.codigo} key={key}>
                  {o.nombre}
              </option>
            );
        })
        }</select>
    )
}

export default Test;